<template>
  <div>
    <modify-table ref="orders" @clearDetails="clearDetails" @showDetails="showDetails"/>
    <modify-detail ref="details"/>
  </div>
</template>

<script>
import ModifyTable from '@/views/inbound/modify/ModifyTable.vue'
import ModifyDetail from '@/views/inbound/modify/ModifyDetail.vue'

export default {
  name: 'Modify',
  components: { ModifyTable, ModifyDetail },
  data() {
    return {}
  },
  methods: {
    refresh() {
      this.$refs.orders.refresh()
    },
    showDetails(row) {
      this.$refs.details.refresh(row.order.id)
    },
    clearDetails() {
      this.$refs.details.clear()
    }
  }
}
</script>